import { Badge } from '@/components/ui/badge';
import { PickingJobSegment, PickingJobStatus } from '@/graphql/generatedTypes';
import {
  pickingJobSegmentLabel,
  pickingJobStatusLabel,
} from './pickingJobLabels';

export function PickingJobStatusBadge({
  status,
}: {
  status: PickingJobStatus;
}) {
  // DELIVERY_INCOMPLETE is the one status that always means someone has to
  // look: the orders are already marked delivered while items are not.
  const isProblem = status === PickingJobStatus.DeliveryIncomplete;
  // RELEASED is not a problem — it is a problem somebody already resolved by
  // hand. It still earns its own colour, because a released job looks like an
  // ordinary closed one otherwise and the intervention is the whole point of
  // keeping the row.
  const isReleased = status === PickingJobStatus.Released;
  if (isReleased) {
    return <Badge variant="outline">{pickingJobStatusLabel(status)}</Badge>;
  }
  return (
    <Badge variant={isProblem ? 'destructive' : 'secondary'}>
      {pickingJobStatusLabel(status)}
    </Badge>
  );
}

export function PickingJobSegmentBadge({
  segment,
}: {
  segment: PickingJobSegment;
}) {
  return <Badge variant="outline">{pickingJobSegmentLabel(segment)}</Badge>;
}
